import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import Button from '../../components/Button/Button'
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router';
import { ArrowRight } from 'react-feather';
import { ReviewsCarousel } from '../../components/ReviewsCarousel/ReviewsCarousel';
import validateConsumerSignUp from '../../Utils/validateConsumerSignUp';
import ErrorBanner from '../../components/ErrorBanner/ErrorBanner';
import advisorProfileService from '../../services/advisorProfile.service';
import useMixPanelEvent from '../../Utils/MixPanel';
import '../Register/Register.scss'

function ConsumerApply(props) {

    const mixpanelTrack = useMixPanelEvent();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [errors, setErrors] = useState({});
    const [errorBannerText, setErrorBannerText] = useState('Something went wrong. Please try again.')
    const [showErrorBanner, setShowErrorBanner] = useState(false);
    const [policyAgreement, setPolicyAgreement] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (password === '' || confirmPassword === '' || email === '' || !policyAgreement) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }

    }, [password, confirmPassword, email, policyAgreement]);

    async function handleSubmit(event) {
        event.preventDefault();
        const validate = validateConsumerSignUp({ email, password, confirmPassword });

        if (Object.keys(validate).length === 0 && policyAgreement) {
            try {
                setDisabled(true);
                setShowErrorBanner(false);
                // check if email exisits in professionals DB 
                let { status } = await advisorProfileService.checkEmail(email);
                if (status === 404) { // email doesnt exist 
                    mixpanelTrack('Consumer sign up', 'Email', email);
                    await signUp()
                    navigate(`/register/verify/${'Consumer'}/${email}/`, { replace: true })
                } else if (status === 200) {
                    setErrorBannerText('You have already applied as a advisor with this email. Please try a different email');
                    setShowErrorBanner(true);
                }

            } catch (error) {
                setShowErrorBanner(true);
                throw (new Error(error));
            } finally {
                setDisabled(false);
            }
        } else {
            setErrors(validate)
        }
    };

    async function signUp() {
        try {
            const username = email;
            await Auth.signUp({
                username,
                password
            });
        } catch (error) {
            console.log('error signing up:', error);
            throw (new Error(error));
        }
    }


    return (
        <>
            <div className='page-container'>
                <div class="register-container left">
                    <div className='logo-container'>
                        <a href="https://www.advisorfinder.com" rel="noopener">
                            <img loading="lazy" src='/AdFi-logo-name.svg' alt="/AdFi-logo-name.svg" className='register-logo' />
                        </a>
                    </div>
                    <div className='form-container'>
                        <h1 className='register-header'>Let's Get Started</h1>
                        <p className='register-paragraph' style={{ marginBottom: "10px" }}>Already have an account? <Link to='/signin'>Sign in now</Link> or <Link to="/advisor-apply">apply as an advisor.</Link></p>
                        <div>
                            <Button onClick={() => navigate(`/advisor-apply`)}>Financial Advisors apply here</Button>
                        </div>
                        <div className='line-container'>
                            <hr width={150} className="signup-line" /><p className="signup-line" >or</p><hr width={150} className="signup-line" />
                        </div>
                        <form className="register-form" onSubmit={handleSubmit}>
                            <div className="input-container">
                                <input
                                    className="input full"
                                    id="email"
                                    placeholder='Email'
                                    value={email}
                                    onChange={e => setEmail(e.target.value.replace(/\s/g, ''))}
                                />
                            </div>
                            {errors.email && <p style={{ paddingTop: '10px' }} className='error-message'>{errors.email}</p>}
                            <div className="input-container half-container">
                                <input
                                    className="input half"
                                    type="password"
                                    id="password"
                                    placeholder="Password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                                <input
                                    className="input half"
                                    type="password"
                                    id="confirmpassword"
                                    placeholder="Confirm password"
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                />
                            </div>
                            <div style={{ color: 'grey', opacity: '90%', textAlign: 'left' }}>Must consist of 8+ characters, upper and lowercase characters, 1 digit and 1 special symbol</div>
                            {errors.password && <p className='error-message'>{errors.password}</p>}
                            <div className="checkbox-container">
                                <label className="optionRow">
                                    <input type="checkbox"
                                        value="betaAgreement"
                                        checked={policyAgreement}
                                        onChange={() => setPolicyAgreement(!policyAgreement)} />
                                    <span className="checkmark"></span>
                                    <span>I confirm I read the <a href='https://www.advisorfinder.com/terms-of-service' target="_blank">Terms of Service</a>, <a href='https://www.advisorfinder.com/privacy-policy' target="_blank">Privacy Policy</a>, and <a href='https://www.advisorfinder.com/cookie-policy' target="_blank">Cookie Policy</a> and agree to them. </span>
                                </label>
                            </div>
                            <div className="input-container">
                                <Button color="clear-button" type="submit" disabled={disabled}>Join the AdFi Platform<ArrowRight size={20} /></Button>
                            </div>
                        </form>
                        {showErrorBanner && <ErrorBanner onClick={() => setShowErrorBanner(false)}>{errorBannerText}</ErrorBanner>}
                    </div>
                </div>
                <div class="register-container right">
                    <ReviewsCarousel />
                </div>
            </div>
        </>
    )
}

export default ConsumerApply
